import API from "@/api";
import CustomEmpty from "@/components/Empty";
import { showGlobalLoading } from "@/components/globalLoading";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import useCustomTranslation from "@/hooks/useTranslation";
import {
	dateFormat,
	east8ToEast9,
	formatNumberWithCommas,
	handleBrowserUrl,
	partiallyHideHash,
	pxToRem,
	setDataToClipboard,
} from "@/util/common";
import { InfiniteScroll, PullToRefresh, Image } from "antd-mobile";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import { CoinGamingData, TabType } from "..";
import useRouter from "@/hooks/useRouter";
import CoinGamingPopup from "./CoinGaming";

const RecordModule: React.ForwardRefRenderFunction<any, {}> = ({}, ref) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { params: routerParams } = useRouter();
	const { showLoading, hideLoading } = showGlobalLoading();
	const TABS: TabType[] = ["DepositRecords", "AccessRecords"];
	const firstPage = useRef(false);
	const [data, setData] = useState<any[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 40;
	const activeTab = useRef<TabType>("DepositRecords");

	const [visiblePopup, setVisiblePopup] = useState(false);
	const [coinGamingData, setCoinGamingData] = useState<CoinGamingData>(null);

	const recordApis = {
		DepositRecords: API.finances.apiFinancePayOrderItem,
		AccessRecords: API.finances.apiFinanceCashOrderItem,
	};

	const fetchListHandle = async (isRefresh = false) => {
		try {
			showLoading();
			let pageNum = isRefresh ? 0 : page;
			// itemType 1/game 2/agent的
			const params: {
				page: number;
				pageSize: number;
				itemType: number | string;
			} = {
				page: pageNum,
				pageSize: pageSize,
				itemType: routerParams.type || 1,
			};
			const result: any = await recordApis[activeTab.current](params);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				setHasMore(haveMore);
				if (haveMore) {
					setPage((prevPage) => (isRefresh ? 1 : prevPage + 1));
				}
				setData((prevData) =>
					pageNum === 0 ? contentData : [...prevData, ...contentData]
				);
			}
		} catch (error) {
			console.error("---postUserAgentManagerList--:", error);
		} finally {
			hideLoading();
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await fetchListHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await fetchListHandle();
	};

	const handleTabChange = (tab: TabType) => {
		firstPage.current = true;
		activeTab.current = tab;
		handleRefresh();
	};

	useImperativeHandle(ref, () => ({
		tabChange: handleTabChange,
	}));

	const getOrderStatusMessage = (status: number) => {
		if (status === 1) {
			return t("Approved");
		} else if (status === -1) {
			return t("Refunded");
		}
		return t("Processing");
	};

	useEffect(() => {
		if (!firstPage.current) {
			firstPage.current = true;
			handleRefresh();
		}
	}, []);

	const handleCoinGamingState = (data?: any) => {
		let bool = activeTab.current === "DepositRecords";
		let coinGamingValue: CoinGamingData = null;
		if (bool) {
			coinGamingValue = {
				currency: data.usdt.toString(),
				feeRate: data.fee,
				address: data.address,
				orderId: data.orderId,
				time: data.updateTime,
				type: "DepositRecords",
				logo: data.networkLogo,
				network: data.network,
				status: data.status,
				reason: data.reason,
				uri: handleBrowserUrl(data.network, data.transNo),
			};
		} else {
			coinGamingValue = {
				currency: (data.coin - data.fee).toString(),
				feeRate: data.fee,
				address: data.address,
				orderId: data.orderId,
				time: data.updateTime,
				type: "AccessRecords",
				logo: data.networkLogo,
				network: data.network,
				status: data.status,
				reason: data.reason,
			};
			if (data.status === 1) {
				coinGamingValue.uri = handleBrowserUrl(
					data.network,
					data.transNo
				);
			}
		}

		setCoinGamingData(coinGamingValue);
		setVisiblePopup(true);
	};

	return (
		<div className={classes.recordWrap}>
			<div className={classes.tabNav}>
				{TABS.map((tab) => (
					<div
						className={activeTab.current === tab ? "on" : ""}
						onClick={() => handleTabChange(tab)}
						key={tab}
					>
						{t(tab)}
					</div>
				))}
			</div>
			<PullToRefresh
				onRefresh={handleRefresh}
				canReleaseText={t("canReleaseText")}
				completeText={t("completeText")}
				pullingText={t("pullingText")}
				refreshingText={t("refreshingText")}
			>
				{data.length > 0 ? (
					<ul className={classes.listWrap}>
						{data.map((item: any) => {
							let address = item.fromAddress || item.address;
							let bool = activeTab.current === "DepositRecords";
							let coin = bool ? item.usdt : "-" + item.coin;
							return (
								<li
									onClick={() => handleCoinGamingState(item)}
									key={item.id}
								>
									<div className="up">
										<Image
											src={require("@/assets/images/icons/USDT.png")}
											className="icon"
										/>
										<p
											onClick={() => {
												setDataToClipboard(
													address,
													t("CopySuccess")
												);
											}}
										>
											{partiallyHideHash(address)}
										</p>
										<strong
											className={bool ? "win" : "lose"}
										>
											{formatNumberWithCommas(+coin)}
										</strong>
									</div>
									<div className="down">
										<span>
											{dateFormat(
												east8ToEast9(
													item.updateTime
												).getTime(),
												"YYYY-MM-dd hh:mm:ss"
											)}
										</span>
										<span>
											{activeTab.current ===
											"DepositRecords"
												? t("PaymentCompletion")
												: getOrderStatusMessage(
														item.status
												  )}
										</span>
									</div>
								</li>
							);
						})}
					</ul>
				) : (
					<CustomEmpty />
				)}
				{data.length > 0 && (
					<InfiniteScroll
						loadMore={handleFetchMore}
						hasMore={hasMore}
					>
						<InfiniteScrollContent hasMore={hasMore} />
					</InfiniteScroll>
				)}
			</PullToRefresh>

			<CoinGamingPopup
				visible={visiblePopup}
				data={coinGamingData}
				onClose={() => setVisiblePopup(false)}
				onSubmit={() => {
					setVisiblePopup(false);
				}}
			/>
		</div>
	);
};

export default RecordModule;

const useStyles = createUseStyles({
	recordWrap: {
		paddingTop: pxToRem(10),
	},
	tabNav: {
		position: "relative",
		display: "flex",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		borderBottom: "1px solid #2F3A62",
		"& >div": {
			flex: 1,
			textAlign: "center",
			color: "#FFFFFF30",
			fontSize: pxToRem(14),
			fontWeight: 500,
			fontFamily: "Noto Sans SC",
			padding: {
				top: pxToRem(10),
				bottom: pxToRem(10),
			},
			"&.on": {
				color: "#FFFFFF",
			},
		},

		"&::after": {
			content: '""',
			position: "absolute",
			left: "50%",
			width: "1px",
			height: pxToRem(20),
			top: "50%",
			transform: "translate(-50%, -50%)",
			backgroundColor: "#2F3A62",
		},
	},
	listWrap: {
		"& li": {
			borderBottom: "1px solid #2F3A6266",
			padding: {
				top: pxToRem(16),
				left: pxToRem(20),
				right: pxToRem(22),
				bottom: pxToRem(20),
			},
			"& >div": {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
			},
		},
		"& .up": {
			fontWeight: 500,
			fontSize: pxToRem(16),
			marginBottom: pxToRem(5),
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(6),
			},
			"& p": {
				flex: 1,
				overflow: "hidden",
				color: "#FFFFFF",
			},
			"& strong": {
				color: "#8BFF78",
			},
		},
		"& .down": {
			color: "#868FA8",
			fontWeight: 400,
			fontSize: pxToRem(12),
		},
	},
});
